import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Guard against external scripts/extensions reintroducing Zone in zoneless mode.
const globalScope = globalThis as Record<string, unknown>;
if ('Zone' in globalScope) {
	globalScope['Zone'] = undefined;
	Reflect.deleteProperty(globalScope, 'Zone');
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
